import type { LectureDetailResourcesItemType } from './lectureDetailResourcesItemType';

export type LectureDetailResourcesItem = {
  /** 자료 제목 */
  title?: string;
  type?: LectureDetailResourcesItemType;
  /** 자료 URL */
  url?: string;
};
